import React from 'react'
import PageFooter from '../../components/PageFooter/PageFooter'

const Footer = props => <PageFooter organizationData={props.organizationData} />

export default Footer
